export default {
  title: 'Paramètres',
  reservation_hours_helper: 'Ces horaires définissent quand les clients peuvent réserver en ligne.',
  reservation_hours_alert:
    "Vos horaires de réservation diffèrent de vos horaires d'ouverture. Les clients ne peuvent réserver que pendant les horaires indiqués ici.",
  activated: 'Réservations actives',
  deactivated: 'Réservations inactives',
  buttons: {
    activate: 'Activer',
    deactivate: 'Désactiver',
  },
  error_messages: {
    no_google_place: {
      title: "Le restaurant n'est connecté à aucun établissement Google",
      description: 'Veuillez connecter le restaurant à un établissement Google',
    },
    toggle_failed: 'Impossible de mettre à jour les réservations. Veuillez réessayer.',
  },
};
